export const productsIndex_US = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_US || '';
export const productsIndex_DE = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_DE || '';

export const productsQuerySuggestionsIndex_US =
  process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_QUERY_SUGGESTIONS_INDEX_US || '';
export const productsQuerySuggestionsIndex_DE =
  process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_QUERY_SUGGESTIONS_INDEX_DE || '';

export const PRICE_KEYS = {
  GB: 'standalonePrice.priceGB',
  EU: 'standalonePrice.priceEU',
};

export const CLICKED_OBJECT_ID = 'clickedObjectId';
export const SEARCH_QUERY_ID = 'searchQueryId';
export const IS_SEARCH = 'isSearch';
export const OBJECT_ID_QUERY_ID = 'objectID_queryID';
